import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, showValue = true, count, className = "" }) => {
  const rounded = Math.round(value * 2) / 2;
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((i) => {
          const filled = rounded >= i;
          const half = !filled && rounded >= i - 0.5;
          return (
            <Star
              key={i}
              size={size}
              className={filled || half ? "text-[#F7C948]" : "text-white/20"}
              fill={filled ? "#F7C948" : half ? "url(#half)" : "transparent"}
            />
          );
        })}
      </div>
      {showValue && value > 0 && (
        <span className="text-sm font-semibold text-[#FFF7D6]">{value.toFixed(1)}</span>
      )}
      {typeof count === "number" && count > 0 && (
        <span className="text-xs text-muted-cosmic">({count})</span>
      )}
    </div>
  );
};
